
import { getProductModel } from '@/api';
import { Header } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AutocompleteFinisher from './AutocompleteFinisher.vue';
import ProductTypeSelector from './ProductTypeSelector.vue';

import {
  breakFixServices,
  breakFixServicesText,
  returnOptions,
  returnOptionsList,
  returnOptionsTexts,
} from '@/utils/PortalConstants';
import { JobBFixProducts, JobProductsHiddenData } from '@/models/jobData';
import AutocompleteWithGeneric from '@/components/jobBooking/Goods/AutocompleteWithGeneric.vue';

@Component({
  components: {
    AutocompleteWithGeneric,
    AutocompleteFinisher,
    ProductTypeSelector,
  },
  data() {
    return {
      breakFixServices,
      breakFixServicesText,
      returnOptions,
      returnOptionsList,
      returnOptionsTexts,
    };
  },
})
export default class ProductsBreakFix extends Vue {
  @Prop(Array) public readonly products: JobBFixProducts[];
  @Prop(String) public readonly customerCode: string;

  public autocompleteModel = getProductModel;
  public tabItemsPrevCount = 30; // 10 actually for now

  public tableHeaders: Header[] = [
    { text: 'Model', value: 'model' },
    { text: 'Problem Description', value: 'description' },
    { text: 'Serial number', value: 'serial' },
    { text: 'Triage call', value: 'triage' },
    { text: 'Service', value: 'service' },
  ];

  private defaultTableValue: JobBFixProducts = {
    model: '',
    model_id: -1,
    description: '',
    serial: '',
    quantity: 1,
    from_stop: 1,
    to_stop: 2,
    weight: 0,
    runup: false,
    quant_id: null,
    service: '',
    triage: false,
  };
  public productsHiddenData: JobProductsHiddenData[] = [];

  public stopGoodsCounter = 1;

  // Track which rows are showing the product selector
  private showProductSelector: { [key: number]: boolean } = {};

  //

  // endpoints
  public changeModel(stop, item) {
    this.products[stop].model = item.name;
    this.products[stop].model_id = item.product_id;
  }

  /**
   * Handle showing the product type selector for a specific row
   */
  private handleShowProductSelector(stop: number): void {
    this.$set(this.showProductSelector, stop, true);
  }

  /**
   * Handle canceling the product type selector
   */
  private handleCancelProductSelector(stop: number): void {
    this.$set(this.showProductSelector, stop, false);
  }

  /**
   * Handle selecting a generic product type
   */
  private handleProductTypeSelect(stop: number, item: { product_id: number; name: string }): void {
    this.products[stop].model = item.name;
    this.products[stop].model_id = item.product_id;
    this.$set(this.showProductSelector, stop, false);
  }

  public async blur(event, stop) {
    this.productsHiddenData[stop].serialNumberFilled = false;
    this.productsHiddenData[stop].statusText = '';
  }

  public addMachine(): void {
    this.products.push({
      model: '',
      model_id: -1,
      description: '',
      serial: '',
      quantity: 1,
      service: '',
      triage: false,
      from_stop: 1,
      to_stop: 2,
      weight: 0,
      runup: false,
      quant_id: null,
    });
    this.productsHiddenData.push({
      serialNumberFilled: false,
      statusText: '',
    });
  }

  public deleteItem(item: JobBFixProducts): void {
    const index = this.products.indexOf(item);
    this.products.splice(index, 1);
    // Clean up the selector state for this row
    this.$delete(this.showProductSelector, index);
  }

  @Watch('products', { deep: true })
  private watchToProducts(): void {
    if (this.products) {
      this.stopGoodsCounter = this.products?.length + 1;

      this.products.map((product, idx) => {
        if (!this.productsHiddenData[idx]) {
          this.productsHiddenData.push({
            serialNumberFilled: false,
            statusText: '',
          });
        }
      });

      this.productsHiddenData.length = this.products.length;
    }
    this.$emit('changeProducts', this.products);
  }
}
